import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--admin-layout"
//
// CONEK-1624: the admin sidebar is now Ui::SidebarComponent, which owns its own
// mobile drawer via the ui--sidebar controller (listening for `sidebar:*` window
// events). The admin navbar's mobile hamburger lives OUTSIDE the sidebar's DOM
// scope, so this controller just bridges its clicks into those window events.
// (Previously it hand-managed the drawer/overlay/desktop-collapse; that markup
// moved into the component.)
export default class extends Controller {
  static targets = ["mainContent"]

  openSidebar() {
    window.dispatchEvent(new CustomEvent("sidebar:open"))
  }

  closeSidebar() {
    window.dispatchEvent(new CustomEvent("sidebar:close"))
  }

  toggleSidebar() {
    window.dispatchEvent(new CustomEvent("sidebar:toggle"))
  }
}
